import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useCallback
} from 'react';
import { v4 as uuid } from 'uuid';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { unset, set } from 'lodash';
import { findPath, formatPath, loopTreeData } from './helpers';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';

const context_format = {
  removeNode: () => {},
  treeData: {},
  isModalOpen: false,
  setIsModalOpen: () => {},
  openModal: () => {},
  selectedNode: {},
  createNewLevel: () => {},
  onSubmitModalData: () => {},
  setTypeNodeAction: () => {},
  typeNodeAction: () => {},
  submitDataToBackend: () => {},
  resetTree: () => {},
  availableActions: [],
  availableQueues: [],
  setAvailableActions: () => {},
  setAvailableQueues: () => {}
};

const defaultTreeData = {
  0: {
    id: uuid(),
    level: 1,
    node_queue: undefined,
    mac: {
      level: null,
      idMac: null
    },
    action: {},
    nodes: {},
    isDefault: true,
    hasVariable: false,
    variables: []
  }
};

const DialogTreeContext = createContext(context_format);

export function DialogTreeProvider({ children }) {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [availableActions, setAvailableActions] = useState([]);
  const [availableQueues, setAvailableQueues] = useState([]);
  const [treeData, setTreeData] = useState(defaultTreeData);
  const [selectedNode, setSelectedNode] = useState({});

  const [typeNodeAction, setTypeNodeAction] = useState('');
  const actualLevelAvailableLevels = treeData ? Object.keys(treeData) : [];
  const [nodeActions, setNodeActions] = useState([]);

  const defaultNode = {
    id: uuid(),
    level: selectedNode.level + 1,
    node_queue: undefined,
    mac: {
      level: null,
      idMac: null
    },
    action: {},
    nodes: {},
    isDefault: true,
    hasVariable: false,
    variables: []
  };

  const removeNode = (nodeData) => {
    const newTreeData = { ...treeData };
    loopTreeData(treeData, (node) => {
      if (nodeData?.original.id === node.id) {
        const objectPath = findPath(newTreeData, 'id', node.id);
        const pathArray = formatPath(objectPath, null);
        unset(newTreeData, pathArray);
      }
    });
    setTreeData({ ...newTreeData });
  };

  const onSubmitModalData = (data) => {
    switch (typeNodeAction) {
      case 'ADD_NEW_NODE':
        createNewNode(data);
        break;
      case 'ADD_NEW_NODE_CHILD':
        createNewNode(data);
        break;
      case 'EDIT_NODE':
        editNode(data);
        break;
      default:
        break;
    }
    setIsModalOpen(false);
  };

  const createNewNode = (data) => {
    const level = selectedNode.level;
    const id = selectedNode?.original?.id;
    const newTreeData = { ...treeData };
    const copyTreedata = { ...treeData };
    const objectPath = findPath(newTreeData, 'id', id);
    const pathArray = formatPath(objectPath, typeNodeAction);
    const actualNodeLevel = eval(`treeData${pathArray}`);

    const newNode = {
      id: uuid(),
      level: typeNodeAction === 'ADD_NEW_NODE' ? level : level + 1,
      queueId: data.chooseNodeQueue == true ? data.nodeQueue : undefined,
      numericIdentifier: data.numericIdentifier,
      stringIdentifier: data.stringIdentifier,
      possibleAnswers: data.possibleAnswers,
      action: data.action,
      mac: {
        level: null,
        idMac: null
      },
      nodes: {}
    };

    if (selectedNode.level !== 1) {
      if (typeNodeAction === 'ADD_NEW_NODE_CHILD') {
        newNode.level = selectedNode.level + 1;

        if (
          data.action.type === 'SUBMENU' ||
          data.action.type === 'SUBMENU_BUTTONS'
        ) {
          defaultNode.mac = {
            level: newNode.level,
            idMac: newNode.id
          };
          newNode.nodes = {
            0: defaultNode
          };
        }
        const fatherNodeList = Object.keys(actualNodeLevel.nodes);
        const newNodeId =
          fatherNodeList.length > 0 ? Math.max(...fatherNodeList) + 1 : 0;
        const nodeList = { ...actualNodeLevel.nodes };
        nodeList[newNodeId] = newNode;
        set(copyTreedata, pathArray + 'nodes', nodeList);
        setTreeData({ ...copyTreedata });
        return;
      } else {
        data.mac = {
          level: selectedNode.level,
          idMac: id
        };

        if (selectedNode.nodes && Object.keys(selectedNode.nodes).length >= 1) {
          selectedNode.nodes = {
            ...selectedNode.nodes
          };
        } else {
          const fatherNodeList = Object.keys(selectedNode.nodes);
          const newNodeId =
            fatherNodeList.length > 0 ? Math.max(...fatherNodeList) + 1 : 0;
          const nodeList = { ...selectedNode.nodes };
          nodeList[newNodeId] = data;
          set(copyTreedata, pathArray + 'nodes', nodeList);
          setTreeData({ ...copyTreedata });
          return;
        }
      }
    }

    if (selectedNode.level === 1) {
      if (typeNodeAction === 'ADD_NEW_NODE_CHILD') {
        newNode.level = 1;

        if (
          data.action.type === 'SUBMENU' ||
          data.action.type === 'SUBMENU_BUTTONS'
        ) {
          defaultNode.mac = {
            level: newNode.level,
            idMac: newNode.id
          };
          newNode.nodes = {
            0: defaultNode
          };
        }
        const fatherNodeList = Object.keys(copyTreedata[0].nodes);
        const newNodeId =
          fatherNodeList.length > 0 ? Math.max(...fatherNodeList) + 1 : 0;
        copyTreedata[0].nodes[newNodeId] = newNode;
        setTreeData({ ...copyTreedata });
        return;
      } else {
        data.mac = {
          level: selectedNode.level,
          idMac: selectedNode?.original?.id
        };

        if (selectedNode.nodes && Object.keys(selectedNode.nodes).length >= 1) {
          selectedNode.nodes = {
            ...selectedNode.nodes
          };
        } else {
          const fatherNodeList = Object.keys(selectedNode.nodes);
          const newNodeId =
            fatherNodeList.length > 0 ? Math.max(...fatherNodeList) + 1 : 0;
          const nodeList = { ...selectedNode.nodes };
          nodeList[newNodeId] = data;
          set(copyTreedata, pathArray + 'nodes', nodeList);
          setTreeData({ ...copyTreedata });
          return;
        }
      }
    }

    setTreeData({ ...newTreeData });
  };

  const editNode = (data) => {
    const objectPath = findPath(treeData, 'id', selectedNode?.original?.id);
    const pathArray = formatPath(objectPath, null);

    selectedNode.queueId =
      data.chooseNodeQueue === true ? data.nodeQueue : undefined;

    if (
      selectedNode.nodes &&
      Object.keys(selectedNode.nodes).length === 1 &&
      Object.keys(selectedNode.nodes[0].action).length === 0
    ) {
      delete selectedNode.nodes[0];
    }
    if (selectedNode.isDefault) {
      loopTreeData(treeData, (node) => {
        if (
          node.id === selectedNode?.original?.id &&
          node.level === selectedNode.level
        ) {
          node.action = data.action;
        }
      });
      if (
        data.action.type === 'SUBMENU' ||
        data.action.type === 'SUBMENU_BUTTONS' ||
        data.action.type === 'SEND_AWAIT'
      ) {
        createNewNode(defaultNode);
      }
      setTreeData({ ...treeData });
    }

    loopTreeData(treeData, (node) => {
      if (
        node.id === selectedNode?.original?.id &&
        node.level === selectedNode.level
      ) {
        node.numericIdentifier = data.numericIdentifier;
        node.stringIdentifier = data.stringIdentifier;
        node.possibleAnswers = data.possibleAnswers;
        node.action = data.action;
        node.hasVariable = data.hasVariable;
        node.variables = data.variables;
      }
    });

    if (
      (data.action.type === 'SUBMENU' ||
        data.action.type === 'SUBMENU_BUTTONS') &&
      !selectedNode.isDefault
    ) {
      createNewNode(defaultNode);
    }

    set(treeData, pathArray, selectedNode);
  };

  const validateTreeData = () => {
    let isTreeValid = {
      isValid: true,
      message: ''
    };
    loopTreeData(treeData, (node) => {
      if (Object.keys(node.action).length === 0) {
        isTreeValid = {
          isValid: false,
          message: 'Ação padrão não configurada em todos os níveis'
        };
      } else if (
        node.action.type === 'SUBMENU_BUTTONS' &&
        Object.keys(node.nodes).length <= 4
      ) {
        Object.values(node.nodes).forEach((subNode) => {
          if (
            subNode?.stringIdentifier &&
            subNode?.stringIdentifier.length > 16
          ) {
            isTreeValid = {
              isValid: false,
              message:
                `${subNode.stringIdentifier} do submenu de botões da opção ${node.stringIdentifier} é maior que 16 caracteres` ||
                'Erro'
            };
          }
        });
      }
    });
    return isTreeValid;
  };

  const submitDataToBackend = async (data, isUpdate, id) => {
    const queueId = data.queue_id?.length == 0 ? undefined : data.queue_id;
    const attendantLogin =
      data.attendant_login?.length == 0 ? undefined : data.attendant_login;

    const dataToSend = {
      name: data.treeName,
      dialog: treeData,
      queue_id: queueId,
      attendant_login: attendantLogin
    };

    if (validateTreeData().isValid) {
      if (isUpdate) {
        FlexChatIntegration.putDialogTree(id, dataToSend)
          .then(() => {
            toast.success('Árvore de diálogo atualizada com sucesso');
            history.push('/admin/ChatDialogTree');
          })
          .catch((err) => {
            toast.error(
              err.response.data.message || 'Erro ao atualizar árvore de diálogo'
            );
          });
      } else {
        FlexChatIntegration.postDialogTree(dataToSend)
          .then(() => {
            toast.success('Árvore de diálogo criada com sucesso');
            history.push('/admin/ChatDialogTree');
          })
          .catch((err) => {
            toast.error(
              err.response.data.message || 'Erro ao criar árvore de diálogo'
            );
          });
      }
    } else {
      toast.error(validateTreeData().message);
    }
  };

  const openModal = (nodeData, type) => {
    if (nodeData) {
      setSelectedNode(nodeData);
      setTypeNodeAction(type);
      setIsModalOpen(true);
    }
  };

  const resetTree = useCallback(() => {
    setTreeData({
      0: {
        id: uuid(),
        level: 1,
        mac: {
          level: null,
          idMac: null
        },
        action: {},
        nodes: {},
        isDefault: true
      }
    });

    setSelectedNode({});

    setIsModalOpen(false);

    setTypeNodeAction('');
  }, []);

  useEffect(() => {
    if (!isModalOpen) setSelectedNode({});
  }, [isModalOpen]);

  useEffect(() => {
    FlexChatIntegration.getActionDialogTree()
      .then((response) => {
        setNodeActions(response.data);
      })
      .catch((err) => {
        toast.error('Ocorreu um erro ao carregar as ações do nó');
      });
  }, []);

  return (
    <DialogTreeContext.Provider
      value={{
        removeNode,
        selectedNode,
        treeData,
        setTreeData,
        isModalOpen,
        setIsModalOpen,
        openModal,
        onSubmitModalData,
        typeNodeAction,
        actualLevelAvailableLevels,
        submitDataToBackend,
        resetTree,
        setAvailableActions,
        setAvailableQueues,
        availableActions,
        availableQueues,
        nodeActions
      }}
    >
      {children}
    </DialogTreeContext.Provider>
  );
}

export function useDialogTree() {
  const dialogContext = useContext(DialogTreeContext);
  return dialogContext;
}
